module.exports = __webpack_public_path__ + "static/media/avatar.cb472b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/avatar.svg
// module id = 61
// module chunks = 0